// removed by extract-text-webpack-plugin
module.exports = {"quoteCell":"QuoteCell__quoteCell___26TBn","quoteText":"QuoteCell__quoteText___1LbUQ","demographicTagList":"QuoteCell__demographicTagList___3bs02","demographicTagListItem":"QuoteCell__demographicTagListItem___23N9G","segmentLabel":"QuoteCell__segmentLabel___2Ts0i"};


//////////////////
// WEBPACK FOOTER
// ./src/styles/components/QuoteCell.css
// module id = 1568
// module chunks = 0